import { createFileRoute } from "@tanstack/react-router";
import { MellanoLuukkuDataCollectionView } from "src/tenantCustomizations/tenants/mellano/views/luukku/slotting/MellanoLuukkuDataCollectionView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/mellano/luukku/purchaseSuggestion")({
	staticData: { title: "Ostokehotus", legacyViewKey: "mellanoLuukkuPurchaseSuggestionView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <MellanoLuukkuDataCollectionView modes={["PURCHASE_SUGGESTION"]} />;
}
